import { useEffect } from 'react';

const SUFFIX = 'ActivistARC portal';

/**
 * Names the browser tab after the page you are on.
 *
 * Every screen used to carry the same title, so browser tabs, history entries
 * and the page announcement a screen reader makes on navigation were all
 * identical. Somebody with three tabs open could not tell which was which, and
 * "ActivistARC organization portal" was announced on arrival at every screen -
 * saying nothing about where they had arrived.
 *
 * Called from the shared page components rather than each screen, so a new page
 * gets a title by using the same header as everything else.
 */
export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} · ${SUFFIX}`;

    /*
     * Deliberately no cleanup that restores the previous title.
     *
     * Moving from one page to another unmounts the old and mounts the new, and
     * React does not promise that the old cleanup runs before the new effect.
     * When it did not, the restore overwrote the title the new page had just
     * set, and two screens went back to the default. Every screen sets its own,
     * so there is nothing for a restore to protect.
     */
  }, [title]);
}
